import { FC } from 'react';
import { useSummaryStatus } from 'views/Engagement/hooks';
import EngagementSurveySummaryCard from './EngagementSurveySummaryCard';
import { QuestionSummary } from './types';

interface EngagementSurveySummaryTaskCardProps {
  campaignId: number;
  reportItemId?: number;
  campaignName: string;
  bodyOnly?: boolean;
}

const EngagementSurveySummaryTaskCard: FC<
  EngagementSurveySummaryTaskCardProps
> = ({ campaignName, bodyOnly }) => {
  // Get summary status and shared data from context
  const { engagementData } = useSummaryStatus();

  // Use shared data from context (fetched by UnifiedSummaryGenerationCard)
  const questionSummaries = engagementData?.question_summaries as
    | QuestionSummary[]
    | undefined;

  // Only render when there's actual summary data to display
  // The unified AI Summaries card handles loading/error/generation states
  if (!questionSummaries?.length) {
    return null;
  }

  return (
    <EngagementSurveySummaryCard
      campaignName={campaignName}
      summary={questionSummaries}
      bodyOnly={bodyOnly}
    />
  );
};

export default EngagementSurveySummaryTaskCard;
